import { ATSPrincipalAppCandidatesListTestIds } from 'data-testids/ATS';
import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { sortOptions } from './data';
import { StartAdornmentText, Title } from '../styles';
import auth from 'utils/auth';
import { CandidatesHeaderProps } from 'features/Principal/types/candidatesListTypes';

export const CandidatesHeader: React.FC<CandidatesHeaderProps> = ({ value, onChange }) => {
  const theme = useTheme();
  const user = auth.getUser();

  const handleSelectChange = (event: SelectChangeEvent) => {
    const selectedOption = sortOptions.find((option) => option.ordering === event.target.value);

    if (selectedOption) {
      onChange(selectedOption.ordering);
    }
  };
  const isDesktopSize = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

  const adornment = isDesktopSize ? (
    <StartAdornmentText position="start">Sort by:</StartAdornmentText>
  ) : null;

  return (
    <Stack
      sx={{ width: '100%', paddingBottom: theme.spacing(3) }}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Title variant="h2" data-testid={ATSPrincipalAppCandidatesListTestIds.SCHOOL_NAME}>
        {user?.profile.school.name ? `Candidates for ${user.profile.school.name}` : ''}
      </Title>
      <Box sx={{ width: '25%' }}>
        <Select
          value={value}
          startAdornment={adornment}
          fullWidth
          sx={{
            backgroundColor: theme.palette.white.main,
            borderRadius: theme.shape.borderRadius * 0.5,
          }}
          onChange={handleSelectChange}
          data-testid={ATSPrincipalAppCandidatesListTestIds.SORT_DROPDOWN}
        >
          {sortOptions.map((option) => (
            <MenuItem value={option.ordering} key={option.id}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Stack>
  );
};
